import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import LanguageSelector from './components/LanguageSelector';
import { requestLogin } from "../../store/actionCreators/authentication";
import config from "../../config/config";
import '../../assets/stylesheets/LoginPage.scss';

const { TERMS_AND_CONDITIONS_URL } = config;

const SignIn = ({ }) => {
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [usernameIsEmpty, setUsernameIsEmpty] = useState(false);
    const [passwordIsEmpty, setEmptyPassword] = useState(false);
    // const [userNameIsValid, setUserNameIsValid] = useState(false);
    // const [passwordIsValid, setPasswordIsValid] = useState(false);
    const [passwordIsHidden, setPasswordIsHidden] = useState(true);
    const {loginError, loading} = useSelector(state => state.authData);
    const [usernameError, setUsernameError] = useState('');
    const toggleShow = () => {
        setPasswordIsHidden(!passwordIsHidden);
    };

    const login = (e) => {
        if (e.key === 'Enter') loginUser();
    }

    const changeUsername = (e) => {
        let withoutSpaces = e.target.value.replace(/\s/g, ''),
            //validator = new RegExp("^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$");
            validator = new RegExp("^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$");
        let isValid = (withoutSpaces.length >= 3 && withoutSpaces.length <= 16) && validator.test(withoutSpaces);
        // setUserNameIsValid(isValid);
        setEmptyPassword(false);
        setUsernameIsEmpty(false);
        setUserName(withoutSpaces);
    };

    const changePassword = (e) => {
        let withoutSpaces = e.target.value.replace(/\s/g, ''),
            validator = new RegExp("^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$");
        let isValid = (withoutSpaces.length >= 6 && withoutSpaces.length <= 16) && validator.test(withoutSpaces);
        // setPasswordIsValid(isValid);
        e.target.value.length > 0 ? setEmptyPassword(false) : setEmptyPassword(true)
        setPassword(e.target.value);
    };

    const loginUser = () => {
        if ((password.length > 0) &&
            (username.length > 0)
          ) {
            dispatch(requestLogin({ username, password, skinId: config.globalSkinId }))
        } else {
          !(password.length > 0) && setEmptyPassword(true);
          !(username.length > 0) && setUsernameIsEmpty(true);
        }
    };
    
    useEffect(() => {
        setUsernameError(loginError ? (loginError.code === 400 || loginError.code === 404) : false );
    }, [loginError])

    return (
        <div className="mainLogin" onKeyUp={login}>
            <LanguageSelector />
            <div className='logo'>
                <div className='title'>{t('signIn')} </div>
            </div>
            <div className='inputSection'>
                <div className="userNameField">
                    {t('signInUp.username')}
                    <label className={`${ (usernameError || usernameIsEmpty) ? 'fieldError' : ''}`}>
                        <input type='text' className="userNameInput" placeholder={t('signInUp.username')}
                            onChange={(e) => changeUsername(e)}
                        />
                        { (usernameError || usernameIsEmpty) && <span className={`failedField`}></span> }
                        {/* {(userNameIsValid && !loginError) && <span className={`successField`}></span>} */}
                    </label>
                    <span className="errorMessage alignErr">
                        {/* {((loginError && loginError.code === 400)) ? t.error.signInUp[1] : ""} */}
                        {
                            username.length > 0 ?
                            (loginError && usernameError) && t('error.signInUp.1')
                            : ((loginError || usernameIsEmpty) && t('error.signInUp.7'))
                        }
                    </span>
                </div>
                <div className="passwordField">
                    {t('signInUp.password')}
                    <label className={`${(loginError && loginError.code === 403) || passwordIsEmpty ? 'fieldError' : ''}`}>
                        <input type={passwordIsHidden ? "password" : "text"} placeholder={t('signInUp.password')} onChange={(e) => changePassword(e)} />
                        <button className='password' onClick={toggleShow}>
                            {passwordIsHidden ?
                                <FontAwesomeIcon icon={faEyeSlash} color="white" />
                                : <FontAwesomeIcon icon={faEye} color="grey" />
                            }
                        </button>
                        { (loginError && loginError.code === 403) || passwordIsEmpty && <span className={`failedField`}></span> }
                        {/* {(passwordIsValid && !loginError) && <span className={`successField`}></span>} */}
                    </label>
                    <span className="errorMessage alignErr">
                        {/* {(loginError && (loginError.code === 403) || ((password.length > 0) && !passwordIsValid)) ? t.error.signInUp[2] : ""} */}
                        {
                            (password.length > 0) ?
                            (loginError) && t('error.signInUp.2')
                            : ((loginError || passwordIsEmpty) && t('error.signInUp.7'))
                        }
                    </span>
                </div>
                <p className="forgotPass">
                    <Link className="tertiary" to={`/forgotPassword`}>{t('forgotPassword')}</Link>
                </p>
            </div>

            {/* <div className="errorMessage alignErr outSideFields">
                {(loginError && loginError.message) ? loginError.message : ''}
            </div> */}

            <div className={`login`}>
                <button disabled={loading} onClick={loginUser} className='primary' >
                    {loading ? <FontAwesomeIcon size="20px" icon={faSpinner} color="white" spin> </FontAwesomeIcon> : t('login')}
                </button>
            </div>
            <p className={`registerLink register`}>{t('loginObj.text')}
                <Link className="tertiary" to={`/register`}>{t('loginObj.link')}</Link>
            </p>
            { TERMS_AND_CONDITIONS_URL && <div className="loginPageFooter">
                <a className='tertiary' target="_blank" href={TERMS_AND_CONDITIONS_URL}>{t('messages.subFotterText')}</a>
            </div> }
        </div>
    );
}

export default SignIn;
